import { useId } from 'react-id-generator';
import { isBlankPixel } from 'lib/GoogleAds';
import { find } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { adComponentReadyToLoad, adComponentTearingdown } from 'redux-implementations/googleAds';
import AdConfig from 'lib/AdConfig';
import { AdConfigBeforeInitialization } from 'types/AdConfig';
import State from 'types/State';
import { useDeepCompareEffect } from 'react-use';

export default function useAd(
  adConfig: AdConfigBeforeInitialization,
  load = true
): { elementId: string; isShown: boolean } {
  const [elementId] = useId();
  const dispatch = useDispatch();
  const isEmpty = useSelector<State, boolean>((state) => {
    return find(state?.ads?.slots, { elementId })?.isEmpty ?? false;
  });
  const isShown = Boolean(!isEmpty && !isBlankPixel(elementId));

  useDeepCompareEffect(() => {
    if (load) {
      const defaultConfig = {
        elementId,
      };

      const config = new AdConfig({
        ...adConfig,
        ...defaultConfig,
      });

      dispatch(adComponentReadyToLoad(config.toJSON()));

      return (): void => {
        dispatch(adComponentTearingdown(config.toJSON()));
      };
    }

    return undefined;
    // Ads are weird
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [load, adConfig]);

  return { elementId, isShown };
}
